/**
 * @fileoverview POST handler for the "/engagement/segments" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementSegmentsCacheKeys } from "./constants";
import type { PostEngagementSegmentsProps, EngagementSegmentsResult } from "./types";

export const postEngagementSegments = reactQueryMutationAdapter(
  engagementSegmentsCacheKeys,
  (props: PostEngagementSegmentsProps): Promise<EngagementSegmentsResult> => {
    return fetch("/engagement/segments", "POST", {
      app_group_id: props.appGroupId,
      app_ids: props.appIds ?? [],
      name: props.name,
      description: props.description,
      type: props.type,
      filters: props.filters,
      include_all_apps: props.includeAllAps,
      include_users_without_app: props.includeUsersWithoutApps,
    });
  }
);
